import config from 'config'
import Root from 'containers/Root'
import App from 'containers/App'
import {
  Home,
  CustomHome,
  NotFound
} from 'containers/pages'

import assessor from './assessor/assessor'
import dashboard from './dashboard/dashboard'
import mastercard from './mastercard'
import misc from './misc'
import paypal from './paypal'
import register from './register/register'
import globalpayments from './globalpayments'
import gpWp from './gp-wp'
import mfa from './mfa'

const publicPath = config.publicPath
const routes = [
  {
    component: Root,
    routes: [
      {
        component: App,
        routes: [
          {
            component: Home,
            path: `${publicPath}/`,
            exact: true,
            routes: []
          },
          {
            component: CustomHome,
            path: `${publicPath}/:code([a-z0-9]{2})`,
            exact: true,
            routes: []
          },
          ...misc,
          ...dashboard,
          ...assessor,
          ...mastercard,
          ...paypal,
          ...globalpayments,
          ...gpWp,
          ...register,
          ...mfa,
          {
            component: NotFound,
            key: 'not-found'
          }
        ]
      }
    ]
  }
]

export default routes
